<script lang="ts">
	//# SVELTE
	import { onMount } from 'svelte';
	//# Modules
	import { format } from 'svelte-i18n';
	//# Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//# Design system components
	import { Container, Button, Text, Modal, Alert } from '@Shelly/shelly-design-system';
	import { mobile } from 'src/services/mobile-rework';
	import { HttpClient } from 'src/services/utils/http-client';

	export let showModal = false;
	export let loading = false;
	export let inst = '';
	export let token = '';
	export let callbackSuccess = () => {};
	export let callbackError = (error) => {};

	const handleDeleteAccount = async () => {
		loading = true;

		const config = {
			data: null,
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + token,
			},
		};
		try {
			const res = await new HttpClient(inst).post(`/user/delete_user`, undefined, config);
			if (res?.data?.isok) {
				await callbackSuccess();
			}
		} catch (error) {
			const errorMessageKeys = Object.keys(error?.response?.data?.errors);
			const errorMessage = errorMessageKeys.length
				? error?.response?.data?.errors[errorMessageKeys[0]]
				: $format('error_global');
			callbackError(errorMessage);
		}

		loading = false;
	};

	const handleCloseModal = () => {
		loading = false;
		showModal = false;
	};

	const closeModal = (e: CustomEvent) => {
		if (showModal) {
			e.preventDefault();
			handleCloseModal();
		}
	};

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', closeModal);
			return () => mobile.removeEventListener('back_button', closeModal);
		}
	});
</script>

{#if showModal}
	<Modal
		on:close={closeModal}
		{showModal}
		title={`${capFirstChar(
			$format('button_delete', { default: 'Delete' }),
		)} ${capFirstChar($format('label_account', { default: 'Acount' }))}?`}
		backdropClose={!loading}
		removeScrollPadding
	>
		<Container slot="content" class="pb-0" padding="scrollPaddings">
			<Text class="width-md-auto width-sm-full mb-m">
				{$format('deleting_account_email_link_msg', {
					default:
						'Deleting your account will permanently remove all your homes, devices, scenes, and data. If you have shared access to other homes, that access will also be removed. Any active Premium subscriptions will be terminated. Please note that once deleted, your profile cannot be recovered.',
				})}
			</Text>
			<Alert
				class="mb-s"
				type="warning"
				heading={$format('confirm_deletion_warning', {
					default: 'This action cannot be undone.',
				})}
			/>
		</Container>
		<div slot="footer" class="d-flex justify-content-end">
			<Button
				variant="secondary"
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				responsiveSize={{
					sm: 'm',
				}}
				disabled={loading}
				on:click={handleCloseModal}
			>
				{capFirstChar(
					$format('button_cancel', {
						default: 'cancel',
					}),
				)}
			</Button>
			<Button
				variant="danger"
				{loading}
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				responsiveSize={{
					sm: 'm',
				}}
				on:click={handleDeleteAccount}
			>
				{capFirstChar(
					$format('button_delete_account', {
						default: 'Delete account',
					}),
				)}
			</Button>
		</div>
	</Modal>
{/if}
